import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "forgotPasswordSuccessPage" }
const _hoisted_2 = { class: "container-wrapper" }
const _hoisted_3 = { class: "inner-container d-flex flex-column justify-content-center align-items-center" }
const _hoisted_4 = { class: "inner-container__title" }
const _hoisted_5 = { class: "inner-container__text" }
const _hoisted_6 = { class: "countDown" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "icon" }, [
          _createElementVNode("img", {
            src: "/assets/images/check-circle-success.png",
            alt: ""
          })
        ], -1)),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('password_reminder')), 1),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('password_reminder_sent_to_email')), 1),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('redirecting')) + " " + _toDisplayString(_ctx.countDownTimeInSec) + " s.", 1),
        _createVNode(_component_router_link, {
          to: _ctx.routesConst.LOGIN
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ButtonComponent, { class: "order-status-form-button" }, {
              btnContent: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('next')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ])
  ]))
}